import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getHelptype = () => {
  return http.get("/HelpDesk/GetHelptype", {
    headers: { Authorization: "Bearer " + token },
  });
};

const addHelpIsuues = (data) => {
  return http.post("/HelpDesk/AddHelpIsuues", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateHelpIsuues = (data) => {
  return http.post("/HelpDesk/UpdateHelpIsuues", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteHelpIsuues = (data) => {
  return http.post("/HelpDesk/DeleteHelpIsuues", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getHelpList = (data) => {
  return http.post("/HelpDesk/GetHelpList", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const sortbyTime = (data) => {
  return http.post("/HelpDesk/SortbyTime", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const helpDeskSort = (data) => {
  return http.post("/HelpDesk/HelpDeskSort", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const helpDeskFilter = (data) => {
  return http.post("/HelpDesk/HelpDeskFilter", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateHelpsts = (data) => {
  return http.post("/HelpDesk/UpdateHelp_sts", data, {
    headers: { Authorization: "Bearer " + token },
  });
};



const HelpDeskService = {
  getHelptype,
  addHelpIsuues,
  updateHelpIsuues,
  deleteHelpIsuues,
  getHelpList,
  sortbyTime,
  helpDeskSort,
  helpDeskFilter,
  updateHelpsts
};

export default HelpDeskService;
